/**
 * @module app.cm
 */

import { CaseWithLocalState } from 'app/cm/models/local-state-extensions';
import { isNullOrUndefined } from 'app/shared/lib/utilities';

export class AssignCasesPageContext {

    private selectedCasesMap = new Map<string, Array<CaseWithLocalState>>();

    public clearSelectedCases(ownerId?: string) {
        if(ownerId) {
            this.selectedCasesMap.delete(ownerId);
        }
        else {
            this.selectedCasesMap.clear();
        }
    }
    public getSelectedCases(ownerId?: string): Array<CaseWithLocalState> {
        if(!isNullOrUndefined(ownerId)) {
            return this.selectedCasesMap.get(ownerId) || [];
        } else {
            const results: Array<CaseWithLocalState> = [];
            this.selectedCasesMap.forEach(o => {
                results.push(...o);
            });
            return results;
        }
    }
    public setSelectedCases(ownerId: string, cases: Array<CaseWithLocalState>) {
        this.selectedCasesMap.set(ownerId, cases);
    }

    public clear(): void {
        this.selectedCasesMap.clear();
    }

}
